import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
    CmpsScoreSectionData,
    CmpsScoreSectionTrendData,
    CmpsScoreSectionTrendType,
} from './scorecard-score-section.model';

@Component({
    selector: 'cmps-scorecard-score-section',
    template: `
        <div class="cmps-scorecard-score-section-container">
            <div class="cmps-scorecard-score-section-labels">
                <div class="cmps-scorecard-score-section--item">
                    <h4 class="cmps-scorecard-score-section--item--label">
                        {{ adjustScoreData.scoreLabel }}
                    </h4>
                </div>
            </div>
            <div class="cmps-scorecard-score-section--content">
                <div class="cmps-scorecard-score-section--item">
                    <div class="cmps-scorecard-score-section--item-content">
                        <button
                            cmpsIconButton
                            (click)="selectedAction.emit()"
                            [cmpsTooltipTrigger]="launchScoreCardLabel"
                            placement="top-center"
                        >
                            <h4 [style.color]="trendData.trendColor">
                                {{ adjustScoreData.scoreValue }}
                            </h4>
                        </button>
                        <ng-container
                            *ngIf="
                                trendData && trendData.trend === null;
                                else buttonTemplate
                            "
                        >
                            <span
                                class="cmps-scorecard-score-section--label-na"
                                >{{ trendData.noTrendLabel }}</span
                            >
                        </ng-container>

                        <ng-template #buttonTemplate>
                            <button
                                cmpsIconButton
                                (click)="trendAction.emit($event)"
                                [cmpsTooltipTrigger]="launchTrendLabel"
                                placement="top-center"
                            >
                                <ng-container
                                    *ngIf="
                                        trendData &&
                                            trendData.trend ===
                                                _CmpsScoreSectionTrendType.NO_CHANGE;
                                        else trendTemplate
                                    "
                                >
                                    <cmps-icon
                                        class="cmps-scorecard-score-section--item-no-trend"
                                        svgIcon="__internal:trending-neutral"
                                        [style.fill]="trendData.trendColor"
                                    ></cmps-icon>
                                </ng-container>
                                <ng-template #trendTemplate>
                                    <cmps-icon
                                        [svgIcon]="
                                            trendData &&
                                            trendData.trend ===
                                                _CmpsScoreSectionTrendType.UP
                                                ? '__internal:trending-up'
                                                : '__internal:trending-down'
                                        "
                                        [style.fill]="trendData.trendColor"
                                    ></cmps-icon>
                                </ng-template>
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-score-section',
    },
})
export class CmpsScoreCardScoreSectionComponent {
    @Input() adjustScoreData: CmpsScoreSectionData;
    @Input() trendData: CmpsScoreSectionTrendData;

    @Input() launchScoreCardLabel: string;
    @Input() launchTrendLabel: string;

    @Output() selectedAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() trendAction: EventEmitter<MouseEvent | KeyboardEvent>;

    /** @private */ _CmpsScoreSectionTrendType = CmpsScoreSectionTrendType;
    constructor() {
        this.trendAction = new EventEmitter();
        this.selectedAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.trendAction.complete();
        this.selectedAction.complete();
    }
}
